import { Component, OnInit } from '@angular/core';

import { LanguageService } from '@fry/lib/organisations/language.service';


@Component({
    selector: 'eas-translation-selector',
    templateUrl: './translation-selector.component.html',
    styleUrls: ['./translation-selector.component.css'],
    standalone: false
})
export class TranslationSelectorComponent implements OnInit {
  translationLanguages: any;

  constructor(
    private language: LanguageService,
  ) {

  }

  ngOnInit() {
    this.translationLanguages = this.language.getTranslationLanguages();
  }
}
